<template>
  <div
    v-if="attributes"
    class="product-attributes-fi"
  >
    <div
      v-for="(attribute, idx) in attributes"
      :key="attribute.AttributeKey"
      :class="{
        [`attribute--${idx}`]: true,
        'product-attributes-fi__item': true,
        'product-attributes-fi__item--icon': attribute.Value === 'relevant',
      }"
    >
      <template v-if="attribute?.Value">
        <template v-if="attribute.Value === 'relevant'">
          <icon-fi
            class="product-attributes-fi__icon"
            icon="check"
          />
        </template>
        <template v-else>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <span v-html="attribute.Value" />
        </template>
        <template v-if="attribute.Unit">
          <!-- eslint-disable vue/no-v-html -->
          <span
            class="product-attributes-fi__item__unit"
            v-html="attribute.Unit"
          />
          <!-- eslint-enable vue/no-v-html -->
        </template>
      </template>
      <template v-else> &#8212; </template>
    </div>
  </div>
</template>

<script>
import { IconFi } from 'atoms';
import { mapGetters } from 'vuex';

import breakpointMixin from '@/mixins/breakpointMixin.vue';

export default {
  name: 'ProductAttributesFi',
  components: {
    IconFi,
  },
  mixins: [breakpointMixin],
  props: {
    attributes: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      approvalsEnabled: 'productList/getApprovalsEnabled',
    }),
  },
};
</script>

<style scoped src="./product-attributes-fi" />
